/**
 * F-7: tooltip text for an interview's status chip.
 *
 * Shows the technical reason for:
 *  - an "error" interview (unchanged prior behavior), and
 *  - a "fail" that was caused by a network interruption
 *    (interrupt_reason === "network", decision #5=B) — so a network-caused Fail
 *    surfaces *why* instead of looking like a normal merit failure.
 *
 * Any other status shows no tooltip.
 */
export function getStatusTooltip(status, interview) {
    if (status === "error") {
        return interview === null || interview === void 0 ? void 0 : interview.technical_error;
    }
    if (status === "fail" && (interview === null || interview === void 0 ? void 0 : interview.interrupt_reason) === "network") {
        return interview === null || interview === void 0 ? void 0 : interview.technical_error;
    }
    return "";
}
/**
 * VA-27746: why Download/Share/View are disabled for a given interview.
 *
 * `!interview.final_report` is the one authoritative gate — a report simply
 * doesn't exist yet, whatever the status. This only supplies the *reason*
 * shown in the tooltip, statically per status, so "Interview expired" and
 * "Evaluation still in progress" don't collapse into one generic message.
 * Single source of truth for all three action icons in interviews-table.tsx
 * — do not duplicate this per-icon.
 */
export function getReportUnavailableReason(status) {
    switch (status) {
        case "scheduled":
            return "Report not available — interview hasn't started yet";
        case "in-progress":
            return "Report not available — evaluation still in progress";
        case "expired":
            return "Report not available — interview expired before completion";
        case "error":
            return "Report not available — interview ended in an error";
        case "fail":
        case "pass":
        case "completed":
            // These normally carry a final_report; reaching this fallback means the
            // report is missing despite a terminal status (e.g. still generating).
            return "Report not available — evaluation result is still being generated";
        default:
            return "Report not available for this interview yet";
    }
}
